<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import sendForm from './form/send'
	//import settlementtaskIndex from '@/views/main/supplier/settlement/index.vue'
	export default {
		extends: listBase,
		name: 'reconciliationIndex',
		render(h) {
			this.$slots.mainheader = [
				<el-button size="mini" type="success" onClick={this.settlementtask}>自动结算</el-button>,
				<el-switch style="padding-left:20px" v-model={this.showUnSettlement} onChange={this.unshowUnSettlementChange} active-text="显示未结算" inactive-text=""></el-switch>
				
			]
			this.$slots.aside = [ <settlementtree ref = "settlementtree"key = {this.settlementtreeKey} onSelect = {this.settlementtreeChange}/>
			]
			
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{'月结对账'}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			this.$slots.plug = [ 
				<send-form ref="sendForm" row={this.currentRow} onSend={this.sendemailbatch}  />,
				// <settlementtaskIndex title="创建结算任务" ref="settlementtaskIndex" />
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				currentRow:null,
				showUnSettlement:false,
				moduleName: 'reconciliation',
				windowName: '月结',
				windowType: 'modal',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread:[]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			add() {
		
				if(typeof this.nodeid[0] !== 'number'){
					this.$message.error('请选择日期')
					return
				}
				this.addformShow({task_time:this.nodeid[0]})
			},
			settlementtask(){
				this.$refs.settlementtaskIndex.modalShow()
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field == 'haspaper'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'有',
								closeLabel:'无',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.switchChnage(row)
								}
							}
						}
					}
					if(item.field == 'signfor'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'是',
								closeLabel:'否',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.switchChnage(row)
								}
							}
						}
					}
				})
			},
			switchChnage(row){
				this.$api.reconciliation.updatefromlist(row.id,{haspaper:row.haspaper,signfor:row.signfor})
			},
			settlementtreeChange(e) {
				console.log(e)
				this.parentbread = []
				this.nodeid = e.parentid != 0? [e.id]:e.childrenid
				if(e.parentid!=0){
					this.parentbread.push({id:e.parentid,name:e.parentid})
				}
				this.parentbread.push({id:e.id,name:e.name})
				
					// this.gridOptions.pagerConfig = {
					// 	currentPage: 1,
					// 	pageSize: 20,
					// }
				this.customreload()
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
			reconciliation(row){
				this.editformShow(row,{
					componentname:'reconciliationform'
				})
			},
			unshowUnSettlementChange(e){
				this.foreingKey.unsettlement = e?1:0
				this.customreload()
			},
			sendemail(e){
				this.currentRow = e
				this.$nextTick(()=>{
					this.$refs.sendForm.modalShow()
				})
			},
			sendemailbatch(e){

				let senddata = []
				if(e && e.senddata){
					senddata = e.senddata
				}else{
					let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
					if(data.length==0){
						this.$message.error('请选择数据')
						return
					}
					data.forEach((item)=>{
						let form = {}
						form.wlnid = item.wlnid
						form.roomid = item.roomid
						form.content = '你好 '+window.systemMethods.timestampToDate(item.create_time,'month')+'月对账单  麻烦理好发下哈\n发了之后请@纳智采购-温州小兰 感谢！ 已发的请忽略'
						senddata.push(form)
						
					})
				}
				this.loading = true
				this.$api.reconciliation.send({data:senddata}).then(()=>{
					this.$message.success('发送成功')
					this.loading = false
				},()=>{
					this.loading = false
				})
				console.log(senddata)
			}
			// cellClick({
			// 	row
			// }) {
			// 	this.currentrow = row
			// 	this.$nextTick(() => {
			// 		this.$refs.contractdetail.getdetail()
			// 	})
			// },
		},
		components: {
			settlementtree,
			sendForm,
			//settlementtaskIndex
		}
	}
</script>